import DashboardOpportunityTableRow from './DashboardOpportunityTableRow';
export default DashboardOpportunityTableRow;
